// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__Pw+sy","header":"CardSellers_header__GqTR7","photo":"CardSellers_photo__fcJef","name":"CardSellers_name__PKNyv","link":"CardSellers_link__kLqD1"};